// extracted by mini-css-extract-plugin
export default {"linkDropOverlay":"DropAnything_linkDropOverlay__CSUJt","linkDropCard":"DropAnything_linkDropCard__Goo0-","linkDropCardStandDown":"DropAnything_linkDropCardStandDown__icV4e"};